import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Welcome to React 18</h1>
    </div>
  );
}

export default App;
